import Loading from "components/utils/Loading";
import React, { memo } from "react";

const LoadingScreen: React.FC = () => {
  return (
    <div className="relative transition-all duration-200 flex bg-white items-center justify-center h-screen text-center ">
      <Loading className="text-9xl text-black" />
    </div>
  );
};

export default memo(LoadingScreen);
